module.exports = __webpack_public_path__ + "9e1765d5b166412bef21ade2e68b668e.svg";